export default "__VITE_ASSET__BzWkd4oe__"